import React from "react";
import connect from "../i18n/connect";
import {
  startFullPageLoader,
  stopFullPageLoader
} from "../redux/modules/fullPageLoader";
import { getFullPageLoaderLoading } from "../redux/modules/fullPageLoader/selector";

export default function withFullPageLoader(WrappedComponent) {
  const mapStateToProps = state => ({
    fullPageLoader: getFullPageLoaderLoading(state)
  });

  const mapDispatchToProps = {
    startFullPageLoader,
    stopFullPageLoader
  };
  @connect(mapStateToProps, mapDispatchToProps)
  class WithFullPageLoader extends React.Component {
    componentDidUpdate(prevProps) {
      if (this.props.fullPageLoader && !prevProps.fullPageLoader) {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth"
        });
      }
    }
    render() {
      return <WrappedComponent {...this.props} />;
    }
  }

  return WithFullPageLoader;
}
